import * as copyToclipboard from 'copy-to-clipboard';
import * as React from 'react';
import {ReactElement} from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType, TextInput} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';
import InlineInput from '../InlineInput/InlineInput';

export default class ShareReviewLink extends React.Component<ShareReviewLinkProps, {}> {
   readonly state: ShareReviewLinkState = {
      copyButtonClicked: false
   };

   constructor(props: ShareReviewLinkProps) {
      super(props);
      autoBind(this);
   }

   onClickCopy(): void {
      copyToclipboard(this.props.reviewUrl);
      this.setState({copyButtonClicked: true});
   }

   onClickUrl(event: any): void {
      event.target.select();
      this.setState({copyButtonClicked: false});
   }

   render(): ReactElement<any> {
      const {themeName} = this.props;
      const shareReviewLinkStrings = Strings.labels.shareReviewLink;
      const buttonText = this.state.copyButtonClicked ? shareReviewLinkStrings.copied : shareReviewLinkStrings.copy;
      const textIntput = <TextInput themeName={themeName} value={this.props.reviewUrl} readOnly={true} onClick={this.onClickUrl} />;
      const controlButton = <ControlButton themeName={themeName} buttonType={TscButtonType.secondary} label={buttonText} onClick={this.onClickCopy} width="4.75rem" testId="share-review-copy" />;

      return (
         <div className="share-review-link-container share-review-section">
            <div className="share-review-link-title">{shareReviewLinkStrings.title}</div>
            <InlineInput middleComponent={textIntput} rightComponent={controlButton} />
         </div>
      );
   }
}

export interface ShareReviewLinkProps extends Themeable {
   reviewUrl: string;
}

export interface ShareReviewLinkState {
   copyButtonClicked: boolean;
}
